import React from 'react'
import { Modal, ModalBody } from "react-bootstrap";
import Loader from '../../shared/Loader/Loader';
import handleNumericCheck from '../../../utils/HandleNumericKeys';

const StatusConfirmationPopup = (props) => {

    const { isPopupOpen, modal, onClose, handleSave, name, searchParam, setSearchParam } = { ...props }
    // const [isLoading, setIsLoading] = useState(false);

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        let modal = { ...searchParam }
        modal[name] = value;
        setSearchParam(modal);
    }

    return (
        <div>

            <Modal show={isPopupOpen} onHide={isPopupOpen} backdrop="static" keyboard={false} centered dialogClassName="delete-modal hk-modal-v1 za-exit-group za-appointment_confirm_popup za_add_reason_popup">
                {/* {isLoading ? <Loader /> : <></>} */}
                <Modal.Body>
                    <div className="input">

                        <label className='text fs-12 ar-light-color mb-1'>{(searchParam?.AppointmentStatusID === '5' || searchParam?.AppointmentStatusID === '10') ? 'Which Room ?' : 'Add Reason'}</label>
                        <input type="text" className='form-control fc-xs rounded-1' onKeyPress={(event) => { (searchParam?.AppointmentStatusID === '5' || searchParam?.AppointmentStatusID === '10') && handleNumericCheck(event) }} id={name} name={name} value={searchParam?.Reason} onChange={handleOnChange} />
                    </div>

                </Modal.Body>
                {/* <div className="modal_footer  ar-border-color br-top-1 ">
                    <div className='za-button text-end'>
                        <button className='btn btn-cancel text fs-12 px-10' onClick={() => { onClose(); handleOnChange({ target: { name: "Reason", value: "" } }) }}> Cancel</button>
                        <button className='btn btn-orange text fs-12 px-10 text-white' onClick={() => { handleSave(searchParam) }}> Save</button>
                    </div>
                </div> */}
                <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                    <button className='btn btn-outline  px-10 h-100 dark-clr'  onClick={() => { onClose(); handleOnChange({ target: { name: "Reason", value: "" } }) }}> Cancel</button>
                    <button className='btn btn-validate px-10 h-100' onClick={() => { handleSave(searchParam) }}> Save</button>
                </div>

            </Modal>
        </div>
    )
}

export default StatusConfirmationPopup
